
// 名前を指定してimport
import { MyClass } from "./hoge/MyClass";
import { IKMoji } from "./hoge/IKMoji";
import { Segment } from './hoge/Segment';
import $ from 'jquery';
import dat from 'dat.gui'



var kita:MyClass = new MyClass('Kita', 70);
console.log(kita.name);

//
var isPause = false;
var isFloor = false;

$(function(){

    console.log('jQuery is ready.');
    kita.Say();

    var ikMoji1:IKMoji = new IKMoji("KITASENJU DESIGN™","title");
    var ikMoji2:IKMoji = new IKMoji("☞Weblog","link1");
    var ikMoji3:IKMoji = new IKMoji("☞Twitter","link2");
    var ikMoji4:IKMoji = new IKMoji("☞Instagram","link3");
    var ikMoji5:IKMoji = new IKMoji("☞Github","link4");
    var ikMoji6:IKMoji = new IKMoji("☞Work","link5");

    var allSegs:Segment[] = [];

    
    
    ikMoji1.allSegs=[];
    //ikMoji2.allSegs=[];
    //ikMoji3.allSegs=[];
    //ikMoji4.allSegs=[];
    //ikMoji5.allSegs=[];
    //ikMoji6.allSegs=[];
    
    ikMoji1.allSegs=ikMoji1.allSegs.concat(
        ikMoji1.segs,ikMoji2.segs,ikMoji3.segs,ikMoji4.segs,ikMoji5.segs,ikMoji6.segs
    );
    //ikMoji2.allSegs=ikMoji2.allSegs.concat(ikMoji1.segs,ikMoji3.segs,ikMoji4.segs,ikMoji5.segs,ikMoji6.segs);
    //ikMoji3.allSegs=ikMoji3.allSegs.concat(ikMoji1.segs,ikMoji2.segs,ikMoji4.segs,ikMoji5.segs,ikMoji6.segs);
    //ikMoji4.allSegs=ikMoji4.allSegs.concat(ikMoji1.segs,ikMoji2.segs,ikMoji3.segs,ikMoji5.segs,ikMoji6.segs);
    //ikMoji5.allSegs=ikMoji5.allSegs.concat(ikMoji1.segs,ikMoji2.segs,ikMoji3.segs,ikMoji4.segs,ikMoji6.segs);
    //ikMoji6.allSegs=ikMoji6.allSegs.concat(ikMoji1.segs,ikMoji2.segs,ikMoji3.segs,ikMoji4.segs,ikMoji5.segs);

    $("#btn2").click(()=>{
        
        isFloor=!isFloor;
        ikMoji1.isFloor = isFloor;
        ikMoji2.isFloor = isFloor;
        ikMoji3.isFloor = isFloor;
        ikMoji4.isFloor = isFloor;
        ikMoji5.isFloor = isFloor;
        ikMoji6.isFloor = isFloor;

        $("#btn2").text( isFloor ? "◎" : "◆" );
        

    });

    $("#btn").click(()=>{

        ikMoji1.Pause();
        ikMoji2.Pause();
        ikMoji3.Pause();
        ikMoji4.Pause();
        ikMoji5.Pause();
        ikMoji6.Pause();
        $("#btn").text( isPause ? "PAUSE" : "PLAY" );
        isPause=!isPause;

    });

});